/* Reading-sample modal: paginates a block of prose into fixed, non-scrolling
   pages sized to the space the dialog actually has, so it reads like a book
   rather than a scrollable blob.

   The behaviour here is lifted unchanged from the inline script in
   main-product-cowboyland.liquid, where it was written. It lives in an asset so
   a second page can use the same reader instead of carrying its own copy. The
   markup comes from the `amm-sample-reader` snippet; the look is whatever the
   host page's stylesheet paints the .cl-* classes, which is why no styling
   lives here.

   Each instance is found by its [data-cl-sample-root] wrapper, so more than one
   can sit on a page. Openers are looked up inside that wrapper. */

(function () {
  function init(root) {
    if (root.ammSampleReaderReady) return;

    var modal = root.querySelector('[data-cl-sample-modal]');
    if (!modal) return;
    root.ammSampleReaderReady = true;

    var source = modal.querySelector('[data-cl-sample-source]');
    var pageHost = modal.querySelector('[data-cl-sample-pages]');
    var pages = [];
    var prev = modal.querySelector('[data-cl-sample-prev]');
    var next = modal.querySelector('[data-cl-sample-next]');
    var count = modal.querySelector('[data-cl-sample-count]');
    var buy = modal.querySelector('[data-cl-sample-buy]');
    var body = modal.querySelector('[data-cl-sample-body]');
    var openers = root.querySelectorAll('[data-cl-sample-open]');
    var closer = modal.querySelector('[data-cl-sample-close]');
    var index = 0;
    var lastFocused = null;

    // Flatten the source into atoms: an image block is a page of its own,
    // everything else flows and gets distributed across pages.
    function collectItems() {
      var items = [];
      Array.prototype.forEach.call(source.children, function (child) {
        if (child.hasAttribute('data-cl-fixed-page')) {
          items.push({ fixed: true, node: child });
        } else if (child.hasAttribute('data-cl-flow-group')) {
          Array.prototype.forEach.call(child.children, function (n) {
            items.push({ fixed: false, node: n });
          });
        } else {
          items.push({ fixed: false, node: child });
        }
      });
      return items;
    }

    // Fill pages up to the height actually available, so nothing scrolls.
    function paginate() {
      var styles = window.getComputedStyle(body);
      var usable =
        body.clientHeight - parseFloat(styles.paddingTop) - parseFloat(styles.paddingBottom);
      if (!(usable > 0)) return false;

      pageHost.textContent = '';
      pages = [];

      var current = null;

      function startPage() {
        current = document.createElement('div');
        current.className = 'cl-sample-page';
        current.setAttribute('data-cl-sample-page', '');
        pageHost.appendChild(current);
        pages.push(current);
        return current;
      }

      collectItems().forEach(function (item) {
        if (item.fixed) {
          // Give full-page items the measured height in pixels. Relying on a
          // percentage chain through the flex layout doesn't resolve, and the
          // cover then overflows on short viewports. Text pages keep auto
          // height so the overflow check below stays meaningful.
          var solo = startPage();
          solo.classList.add('cl-sample-page--fixed');
          solo.style.height = usable + 'px';
          solo.appendChild(item.node.cloneNode(true));
          current = null;
          return;
        }
        if (!current) startPage();
        current.appendChild(item.node.cloneNode(true));
        if (current.scrollHeight > usable && current.children.length > 1) {
          // Overflowed -- move the offending node onto a fresh page. A single
          // node taller than the viewport is left alone rather than looping.
          current.removeChild(current.lastElementChild);
          startPage().appendChild(item.node.cloneNode(true));
        }
      });

      return pages.length > 0;
    }

    function render() {
      if (!pages.length) return;
      if (index > pages.length - 1) index = pages.length - 1;
      if (index < 0) index = 0;

      var isLast = index === pages.length - 1;
      pages.forEach(function (p, i) {
        p.hidden = i !== index;
      });
      prev.disabled = index === 0;
      // The buy CTA takes Next's place on the final page.
      next.hidden = isLast;
      if (buy) buy.hidden = !isLast;
      count.textContent = 'Page ' + (index + 1) + ' of ' + pages.length;
    }

    function open() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      index = 0;
      // Must happen while visible -- a hidden element measures zero.
      paginate();
      render();
      closer.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key === 'ArrowRight' && index < pages.length - 1) {
        index++;
        render();
        return;
      }
      if (event.key === 'ArrowLeft' && index > 0) {
        index--;
        render();
        return;
      }
      if (event.key !== 'Tab') return;

      // Keep focus inside the dialog while it is open. Hidden and disabled
      // controls are skipped -- Next and the buy CTA swap places per page.
      var focusables = Array.prototype.filter.call(
        modal.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'),
        function (el) {
          return !el.disabled && !el.hidden && el.offsetParent !== null;
        }
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    Array.prototype.forEach.call(openers, function (button) {
      button.addEventListener('click', open);
    });
    closer.addEventListener('click', close);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) close();
    });
    prev.addEventListener('click', function () {
      if (index > 0) {
        index--;
        render();
      }
    });
    next.addEventListener('click', function () {
      if (index < pages.length - 1) {
        index++;
        render();
      }
    });

    if (buy) {
      buy.addEventListener('click', function () {
        close();
        // Which control to send the reader to is the host page's business: a
        // sales page wants its add-to-cart button, the product page its own.
        var target = root.querySelector(
          root.getAttribute('data-cl-sample-buy-target') || '[data-cl-sample-buy-focus]'
        );
        if (target) {
          target.scrollIntoView({ block: 'center', behavior: 'smooth' });
          target.focus({ preventScroll: true });
        }
      });
    }

    // Reflow when the space available changes -- resize, rotate, or the
    // design fonts arriving and changing the text metrics.
    var reflowTimer = null;
    function reflow() {
      if (modal.hidden) return;
      clearTimeout(reflowTimer);
      reflowTimer = setTimeout(function () {
        var ratio = pages.length ? index / pages.length : 0;
        paginate();
        index = Math.round(ratio * pages.length);
        render();
      }, 150);
    }

    window.addEventListener('resize', reflow);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(reflow);
    }

    // Swipe to turn pages. Without this, a phone-sized sample is a lot of
    // taps on Next, since less text fits per page.
    var touchX = null;
    var touchY = null;

    body.addEventListener(
      'touchstart',
      function (event) {
        touchX = event.changedTouches[0].clientX;
        touchY = event.changedTouches[0].clientY;
      },
      { passive: true }
    );

    body.addEventListener(
      'touchend',
      function (event) {
        if (touchX === null) return;
        var dx = event.changedTouches[0].clientX - touchX;
        var dy = event.changedTouches[0].clientY - touchY;
        touchX = null;
        touchY = null;
        // Ignore mostly-vertical drags and small accidental movements.
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0 && index < pages.length - 1) {
          index++;
          render();
        } else if (dx > 0 && index > 0) {
          index--;
          render();
        }
      },
      { passive: true }
    );
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cl-sample-root]').forEach(init);
  }

  initAll();

  // An external script does not re-run when the theme editor re-renders a
  // section, so the new markup would arrive with no reader attached. The guard
  // flag on each root keeps this from binding a second set of listeners to
  // instances that survived.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
